import { configureStore } from '@reduxjs/toolkit'
import projectsReducer from '../Redux/projectsSlice'
import backgroundEffectReducer from '../Redux/BackgroundEffectSlice'
import userReducer from '../Redux/userSlice'
import nexReducer from '../Redux/nexSlice'


export default configureStore({
    reducer: {
        projects: projectsReducer,
        bgEffect: backgroundEffectReducer,
        user: userReducer,
        nex: nexReducer
    }
})